import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TTeam } from '../types/team.type';

/**
 *
 */
export const DeleteAgentOnTeamSchema = z.object({
  teamId: z.string().min(1),
  userIds: z.array(z.string()).min(1),
});
export type TDeleteAgentOnTeamValidation = z.infer<typeof DeleteAgentOnTeamSchema>;
export type TDeleteAgentOnTeamPayload = TDeleteAgentOnTeamValidation;
export type TDeleteAgentOnTeamResponse = ApiResponse<TTeam>;

export const deleteAgentOnTeam = async (payload: TDeleteAgentOnTeamPayload): Promise<TDeleteAgentOnTeamResponse> => {
  const url = `/team/delete-user/${payload.teamId}`;

  const payloadData = {
    userIds: payload.userIds,
  };

  return axiosInstance.patch(url, payloadData);
};

/**
 *
 */
type TUseDeleteAgentOnTeamOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteAgentOnTeam, AxiosErrorCustom>;
};

export const useDeleteAgentOnTeam = ({ mutationConfig }: TUseDeleteAgentOnTeamOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TDeleteAgentOnTeamResponse, AxiosErrorCustom, TDeleteAgentOnTeamPayload>({
    mutationFn: deleteAgentOnTeam,
    ...restConfig,
  });
};
